import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _get from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { CalendarDate as $35ea8db9cb2ccb90$export$99faa760c7908e4f } from "./CalendarDate.module.js";
import { GregorianCalendar as $3b62074eb05584b2$export$80ee6245ec4f29ec } from "./GregorianCalendar.module.js";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.

var $62225008020f0a13$var$ERA_START_DATES = [[1868, 9, 8], [1912, 7, 30], [1926, 12, 25], [1989, 1, 8], [2019, 5, 1]];
var $62225008020f0a13$var$ERA_END_DATES = [[1912, 7, 29], [1926, 12, 24], [1989, 1, 7], [2019, 4, 30]];
var $62225008020f0a13$var$ERA_ADDENDS = [1867, 1911, 1925, 1988, 2018];
var $62225008020f0a13$var$ERA_NAMES = ['meiji', 'taisho', 'showa', 'heisei', 'reiwa'];

function $62225008020f0a13$var$findEraFromGregorianDate(date) {
  var idx = $62225008020f0a13$var$ERA_START_DATES.findIndex(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        year = _ref2[0],
        month = _ref2[1],
        day = _ref2[2];

    if (date.year < year) return true;
    if (date.year === year && date.month < month) return true;
    if (date.year === year && date.month === month && date.day < day) return true;
    return false;
  });
  if (idx === -1) return $62225008020f0a13$var$ERA_START_DATES.length - 1;
  if (idx === 0) return 0;
  return idx - 1;
}

function $62225008020f0a13$var$toGregorian(date) {
  var eraAddend = $62225008020f0a13$var$ERA_ADDENDS[$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
  if (!eraAddend) throw new Error('Unknown era: ' + date.era);
  return new (0, $35ea8db9cb2ccb90$export$99faa760c7908e4f)(date.year + eraAddend, date.month, date.day);
}

var $62225008020f0a13$export$b746ab2b60cdffbf = /*#__PURE__*/function (_ref3) {
  function $62225008020f0a13$export$b746ab2b60cdffbf() {
    var _this2;

    _classCallCheck(this, $62225008020f0a13$export$b746ab2b60cdffbf);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper(this, $62225008020f0a13$export$b746ab2b60cdffbf, [].concat(args)), _this2.identifier = 'japanese';
    return _this2;
  }

  _inherits($62225008020f0a13$export$b746ab2b60cdffbf, _ref3);

  return _createClass($62225008020f0a13$export$b746ab2b60cdffbf, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = _get(_getPrototypeOf($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "fromJulianDay", this).call(this, jd);

      var era = $62225008020f0a13$var$findEraFromGregorianDate(date);
      return new (0, $35ea8db9cb2ccb90$export$99faa760c7908e4f)(this, $62225008020f0a13$var$ERA_NAMES[era], date.year - $62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return _get(_getPrototypeOf($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "toJulianDay", this).call(this, $62225008020f0a13$var$toGregorian(date));
    }
  }, {
    key: "balanceDate",
    value: function balanceDate(date) {
      var gregorianDate = $62225008020f0a13$var$toGregorian(date);
      var era = $62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);

      if ($62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
        date.era = $62225008020f0a13$var$ERA_NAMES[era];
        date.year = gregorianDate.year - $62225008020f0a13$var$ERA_ADDENDS[era];
      } // Constrain in case we went before the first supported era.


      this.constrainDate(date);
    }
  }, {
    key: "constrainDate",
    value: function constrainDate(date) {
      var idx = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
      var end = $62225008020f0a13$var$ERA_END_DATES[idx];

      if (end != null) {
        var _end2 = _slicedToArray(end, 3),
            endYear = _end2[0],
            endMonth = _end2[1],
            endDay = _end2[2]; // Constrain the year to the maximum possible value in the era.
        // Then constrain the month and day fields within that.


        var maxYear = endYear - $62225008020f0a13$var$ERA_ADDENDS[idx];
        date.year = Math.max(1, Math.min(maxYear, date.year));

        if (date.year === maxYear) {
          date.month = Math.min(endMonth, date.month);
          if (date.month === endMonth) date.day = Math.min(endDay, date.day);
        }
      }

      if (date.year === 1 && idx >= 0) {
        var _$62225008020f0a13$va2 = _slicedToArray($62225008020f0a13$var$ERA_START_DATES[idx], 3),
            startMonth = _$62225008020f0a13$va2[1],
            startDay = _$62225008020f0a13$va2[2];

        date.month = Math.max(startMonth, date.month);
        if (date.month === startMonth) date.day = Math.max(startDay, date.day);
      }
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return $62225008020f0a13$var$ERA_NAMES;
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra(date) {
      // Get the number of years in the era, taking into account the date's month and day fields.
      var era = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
      var cur = $62225008020f0a13$var$ERA_START_DATES[era];
      var next = $62225008020f0a13$var$ERA_START_DATES[era + 1];
      if (next == null) // 9999 gregorian is the maximum year allowed.
        return 9999 - cur[0] + 1;
      var years = next[0] - cur[0];
      if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
      return years;
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      return _get(_getPrototypeOf($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "getDaysInMonth", this).call(this, $62225008020f0a13$var$toGregorian(date));
    }
  }, {
    key: "getMinimumMonthInYear",
    value: function getMinimumMonthInYear(date) {
      var start = $62225008020f0a13$var$getMinimums(date);
      return start ? start[1] : 1;
    }
  }, {
    key: "getMinimumDayInMonth",
    value: function getMinimumDayInMonth(date) {
      var start = $62225008020f0a13$var$getMinimums(date);
      return start && date.month === start[1] ? start[2] : 1;
    }
  }]);
}((0, $3b62074eb05584b2$export$80ee6245ec4f29ec));

function $62225008020f0a13$var$getMinimums(date) {
  if (date.year === 1) {
    var idx = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
    return $62225008020f0a13$var$ERA_START_DATES[idx];
  }
}

export { $62225008020f0a13$export$b746ab2b60cdffbf as JapaneseCalendar };